/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Eye0(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Eye0.glb')
  return (
    <group {...props} dispose={null}>
      <group position={[0.38, 298.38, 120.63]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Eye0-White'].geometry}
          material={materials.White}
        />
        <mesh castShadow receiveShadow geometry={nodes['Eye0-Black'].geometry}>
          <meshPhysicalMaterial color={colorArr[1]} reflectivity={1} />
        </mesh>
      </group>
    </group>
  )
}

useGLTF.preload('/models/Eye0.glb')
